"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _LinkItem = _interopRequireDefault(require("./LinkItem"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class Level2 extends _react.default.Component {
  render() {
    const {
      links,
      expanded,
      onToggle
    } = this.props;
    if (!links) return false;
    return /*#__PURE__*/_react.default.createElement("nav", {
      className: 'menu-second' + (expanded ? ' expanded' : '')
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: 'menu-second-inner' + (expanded ? ' expanded' : '')
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "clickable-area-top",
      onClick: () => onToggle(!expanded)
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "menu-margin"
    }, links.map((link, index) => {
      return /*#__PURE__*/_react.default.createElement(_LinkItem.default, {
        key: index,
        exact: true,
        link: link,
        expanded: expanded
      });
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "clickable-area",
      onClick: () => onToggle(!expanded)
    })));
  }
}
var _default = exports.default = Level2;
module.exports = exports.default;